import React from 'react';
import PropTypes from 'prop-types';

// Base
import Card from '../../../../../base/card';

// Related Components
import Show from './show';

export default class Listing extends React.Component {
  static propTypes = {
    persona: PropTypes.object.isRequired,
    educationEntry: PropTypes.object.isRequired,
  }

  render() {
    const {  educationEntry } = this.props;

    return (
      <Card
        border='thin'
        className='min-height-0 margin-bottom-10'
      >
        <Show {...{ educationEntry }} />
      </Card>
    )
  }
}